import Vue from "vue";
import AlertComponent from "./alert.vue";
import ConfirmComponent from "./confirm.vue";

let instance;
let confirmInstance;
let AlertConstructor = Vue.extend(AlertComponent);
let ConfirmConstructor = Vue.extend(ConfirmComponent);
let initInstance = () => {
    instance = new AlertConstructor({
        el: document.createElement("div"),
    });
    document.body.appendChild(instance.$el);
};

let initConfirmInstance = () => {
    confirmInstance = new ConfirmConstructor({
        el: document.createElement("div"),
    });
    document.body.appendChild(confirmInstance.$el);
};

let Alert = (path) => {
    initInstance();
    return new Promise((resolve, reject) => {
        instance.path = path;
        instance.show = true;
        let success = instance.success;
        let close = instance.close;
        instance.success = () => {
            success();
            resolve("ok");
        };
        instance.close = () => {
            close();
            reject("no");
        };
    });
};

let Confirm = (title, message) => {
    initConfirmInstance();
    return new Promise((resolve, reject) => {
        confirmInstance.show = true;
        confirmInstance.title = title;
        confirmInstance.message = message;
        let confirm = confirmInstance.confirm;
        let close = confirmInstance.close;
        confirmInstance.confirm = () => {
            confirm();
            resolve("ok");
        };
        confirmInstance.close = () => {
            close();
            reject("no");
        };
    });
};
export default {
    install(Vue) {
        Vue.prototype.$alert = Alert;
        Vue.prototype.$confirm = Confirm;
    },
};
